var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"GREEN-BUBBLE ellipsize"},[_vm._v("\n  "+_vm._s(_vm.bubbleTextLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }